<template>
  <div class="listPage">
    <div class="banner">
      <img src="../../../assets/images/banner3.png" alt="" />
    </div>
    <div class="breadcrumb flex-rowc">
      <div class="breadcrumb_icon3">
        <i class="iconfont icon-pinpaizichanpingtai"></i>
      </div>
      <div class="breadcrumb_item">商务&销售管理</div>
      <div class="breadcrumb_item_arrow"></div>
      <div class="breadcrumb_item">业务订单审核</div>
    </div>

    <div class="input_box flex-between">
      <van-field
        v-model="params.keyword"
        placeholder="输入关键字查找→"
        @focus="handleFocus"
        @blur="handleBlur"
        @keyup.enter="handleSearch"
      />
      <i class="iconfont icon-sousuo" @click="handleSearch"></i>
    </div>

    <div class="screen_wrap flex-rowl">
      <div
        class="item flex-rowc"
        v-for="(item, index) in screenList"
        :key="index + 'a'"
        @click="handleScreen(item)"
      >
        {{ item.txt }}
        <span
          ><i
            class="iconfont icon-checkbox-checked-o"
            v-if="select == item.txt"
          ></i
        ></span>
      </div>
    </div>

   <div class="order_wrap">
      <template v-if="dataList.length > 0">
        <div
          class="order_item"
          v-for="item in dataList"
          :key="item.id"
          @click="handleDetail(item.id, item.openid)"
        >
          <div class="row_one mb">
            <p>订单编号：{{ item.orderno }}</p>
            <p>创建时间：{{ item.createdate | formatDate }}</p>
          </div>
          <div class="row_one mb">
            <p>
              {{ item.ordertypestr }}
            </p>
            <p>销售专员姓名：{{ item.saler_note }}</p>
          </div>

          <div class="row_shop_list row_one" v-if="false">
            <p>
              成本参考价：<span v-if="item.cbprice_sum"
                >¥ {{ item.cbprice_sum }}</span
              >
            </p>
            <p>
              基础零售价：<span v-if="item.price_sum"
                >¥ {{ item.price_sum }}</span
              >
            </p>
            <p>
              批发参考价：<span v-if="item.pfprice_sum"
                >¥ {{ item.pfprice_sum }}</span
              >
            </p>
            <p>
              基础批发价：<span v-if="item.groupprice_sum"
                >¥ {{ item.groupprice_sum }}</span
              >
            </p>
          </div>

          <div class="row_four">
            <div class="txt flex-between">
              <p>订单价格核算：</p>
              <p v-if="item.price_original">
                <span>￥</span>{{ item.price_original | formatPrice }}
              </p>
            </div>
            <div class="txt2 flex-between">
              <p>物流费用：</p>
              <p v-if="item.logisticsdf == 1">到付</p>
              <p v-else>￥{{ item.runfee ? item.runfee : 0 }}</p>
            </div>
          </div>
          <div class="row_four">
            <div class="txt flex-between">
              <p>实际订单价格：</p>
              <p><span>￥</span>{{ item.price | formatPrice }}</p>
            </div>
            <!-- <div class="txt1 flex-between">
            <p>差额：</p>
            <p><span>￥</span>{{ item.runfee }}</p>
          </div> -->
            <div class="txt flex-between">
              <p>已付金额：</p>
              <p v-if="item.paynum">￥{{ item.paynum | formatPrice }}</p>
              <p v-else>￥ 0.00</p>
            </div>
            <div class="txt2 flex-between">
              <p>差额：</p>
              <p>￥{{ item.diffrentprice | formatPrice }}</p>
            </div>
            <div class="txt2 flex-between">
              <p>待结清金额：</p>
              <p>￥{{ item.waitMoney | formatPrice }}</p>
            </div>
          </div>
          <div class="order_status mb">
            <div class="txt flex-between">
              <p>订单审核状态：</p>
              <!-- 	 	  -->

              <p class="red">
                {{
                  item.ischeck == 0
                    ? "待审核"
                    : item.ischeck == 1
                    ? "审核通过"
                    : item.ischeck == 2
                    ? "审核不通过"
                    : ""
                }}
              </p>
            </div>
            <div class="txt flex-between">
              <p>退费申请状态：</p>
              <p class="red">
                {{
                  item.isreturn === true
                    ? "是"
                    : item.isreturn === false
                    ? "否"
                    : "无"
                }}
              </p>
            </div>
            <div class="txt flex-between">
              <p>退费状态：</p>
              <p class="red">
                {{ item.returnstate ? item.returnstate : "无" }}
              </p>
            </div>
            <div class="txt flex-between">
              <p>订单情况：</p>
              <p class="red">
                {{
                  item.ordertalk == 1
                    ? "进行中"
                    : item.ordertalk == 2
                    ? "已完成"
                    : item.ordertalk == 3
                    ? "已关闭"
                    : "无"
                }}
              </p>
            </div>
            <!-- <div class="txt flex-between">
              <p>发货情况：</p>
              <p class="red">{{ item.orderstate }}</p>
            </div> -->
          </div>
          <div class="row_one mb">
            <p>
              客户名称：<span>{{ item.qy_truename }}</span>
            </p>
            <p>
              客户企业：<span>{{ item.qw_appidstr }}</span>
            </p>
            <p>
              客户职务：<span>{{ item.qw_job }}</span>
            </p>
            <p>
              联系方式：<span>{{ item.qy_linktype }}</span>
            </p>
          </div>
          <div class="row_one">
            <p>
              发货统计：<span></span>
            </p>
          </div>
        </div>
      </template>
      <van-empty description="暂无数据" v-else />
    </div>
    <!-- <div class="primary-button return" @click="handleReturn">
      <i class="iconfont icon-yuyinjiantou"></i> 返回业务中心
    </div> -->

    <div class="fixd_button_btm flex-rowl" v-if="isShowTabbar">
      <div class="item return" @click="handleReturn">返回</div>
      <div class="item" @click="handleAdd('')">
        新增订单
      </div>
    </div>

    <!-- <Tabbar v-if="isShowTabbar"></Tabbar> -->
  </div>
</template>

<script>
import { encryptstringadd } from "../../../api/api";
import { getOrderListWeb } from "../../../api/shop";
import { calculator } from "../../../utils/decimal";
// import Tabbar from "../../../components/Tabbar.vue";
import { mapState } from "vuex";
export default {
  name: "cBusinessOrderList",
  components: {
    // Tabbar,
  },
  data() {
    return {
      isShowTabbar: true,
      keyword: "",
      qyid: "",
      screenList: [
        { txt: "全部", type: "", con: "" },
        { txt: "待审核", type: "ischeck", con: 0 },
        { txt: "审核通过", type: "ischeck", con: 1 },
        { txt: "审核不通过", type: "ischeck", con: 2 },
        { txt: "支付未完成", type: "paystate", con: 0 },
        { txt: "已支付完成", type: "paystate", con: 1 },
        { txt: "退费申请待审核", type: "returntalk", con: 1 },
        { txt: "退费申请不通过", type: "returntalk", con: 2 },
        { txt: "退款中", type: "orderstate", con: "已申请退费" },
        { txt: "已退款", type: "orderstate", con: "已退费" },
      ],
      select: "全部",
      dataList: [],
      listTotal: 0,
      type: "",
      params: {
        openid: "",
        ordertype: 43, // 订单类型
        keyword: "",
        qyid: "",
        returntalk: "", // 退款状态
        ischeck: "", // 订单审核
        paystate: "", // 支付状态
        orderstate: "", // 订单状态
        pageindex: 1,
        pagesize: 15,
      },
    };
  },
  filters: {
    // 时间格式化
    formatDate(date) {
      if (!date) return "";
      if (date.indexOf("T") != -1) {
        let dateSplit = date.split("T");
        let dataTime =
          dateSplit[1].indexOf(".") != -1
            ? dateSplit[1].split(".")[0]
            : dateSplit[1];
        return dateSplit[0] + " " + dataTime; // 这里可以根据需要使用不同的日期格式化选项
      } else {
        return date;
      }
    },
    // 价格逗号分隔，保留两位小数
    formatPrice(price) {
      if (!price) "0.00";
      const formattedPrice = Number(price)
        .toFixed(2)
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return formattedPrice;
    },
  },
  computed: {
    ...mapState(["OPENID"]),
  },
  created() {
    this.type = this.$route.params.type;
    this.params.qyid = this.$store.state.USERINFO.qy
      ? this.$store.state.USERINFO.qy.id
      : "";
    // this.params.openid = this.$store.state.OPENID;
    this.getOrderListWeb();
    window.addEventListener("scroll", this.handleSrcoll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleSrcoll);
  },
  methods: {
    // 搜索
    handleSearch() {
      this.params.pageindex = 1
      this.dataList = [];
      this.getOrderListWeb();
    },
    // 筛选
    handleScreen(item) {
      if (item.con == "" && item.type == "") {
        this.params.returntalk = "";
        this.params.ischeck = "";
        this.params.paystate = "";
        this.params.orderstate = "";
      } else if (item.type == "ischeck") {
        this.params.ischeck = item.con;
        this.params.returntalk = "";
        this.params.paystate = "";
        this.params.orderstate = "";
      } else if (item.type == "returntalk") {
        this.params.returntalk = item.con;
        this.params.ischeck = "";
        this.params.paystate = "";
        this.params.orderstate = "";
      } else if (item.type == "paystate") {
        this.params.paystate = item.con;
        this.params.returntalk = "";
        this.params.ischeck = "";
        this.params.orderstate = "";
      } else if (item.type == "orderstate") {
        this.params.orderstate = item.con;
        this.params.returntalk = "";
        this.params.ischeck = "";
        this.params.paystate = "";
      }
      this.select = item.txt;
      this.getOrderListWeb();
    },

    getOrderListWeb() {
      const Toast = this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
      getOrderListWeb(this.params).then((res) => {
        let resNew = res.list;
        resNew.forEach((v) => {
          if (v.goods.length > 0) {
            v.totalNum = 0;
            v.goods.forEach((v1) => {
              v.totalNum += v1.num;
            });
          }
           // 待结清金额 = price - paynum
          v.waitMoney = calculator(v.price)
            .subtract(v.paynum ? v.paynum : 0)
            .toNumber()
        });

        this.dataList = [...this.dataList, ...resNew];
        this.listTotal = res.total;
        this.loading = false;
        Toast.clear();
      });
    },
    // 滚动事件
    handleSrcoll() {
      const windowHeight = window.innerHeight; // 窗口可见高度
      const documentHeight = document.documentElement.scrollHeight; // 文档高度
      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop; // 滚动条距离顶部的距离

      if (
        scrollTop + windowHeight >= documentHeight &&
        !this.loading &&
        this.dataList.length < this.listTotal
      ) {
        this.params.pageindex += 1;
        this.getOrderListWeb();
      }
    },

    handleDetail(id, openid) {
      // this.$router.push(`/comSalesIndex/cOrderDetail/${id}/${openid}`);
      this.encryptstringadd("cOrderDetail", {
        id,
        openid,
        type: "cBusinessOrderList",
      });
    },

    // 新增订单
    handleAdd() {
      this.encryptstringadd("serviceIndex", '');
    },

    // 页面跳转之前对参数进行加密
    async encryptstringadd(name, params) {
      if (params != "") {
        let paramsData = {
          openid: this.OPENID,
          jsondata: JSON.stringify(params),
        };
        const response = await encryptstringadd(paramsData);
        if (response.result) {
          this.$store.commit("cacheRoute", {
            encryptstring: response.encryptstring,
            name,
          });
          this.$router.push({
            name,
            params,
          });
        }
      } else {
        this.$store.commit("cacheRoute", {
          encryptstring: "",
          name,
        });
        this.$router.push({
          name,
          params,
        });
      }
    },

    // 计算商品差价
    shopPriceDifference(price, price1) {
      return calculator(price1).subtract(price).toNumber();
    },

    handleReturn() {
      this.$router.back();
    },

    // 获取焦点
    handleFocus() {
      this.isShowTabbar = false;
    },
    // 失去焦点
    handleBlur() {
      this.isShowTabbar = true;
    },
  },
};
</script>
<style lang="less" scoped>
.listPage {
  padding-bottom: 300px;
  .screen_wrap {
    font-size: 20px;
    color: #464646;
    flex-wrap: wrap;
    margin: 70px 70px 60px;
    .item {
      border: 1px solid #d2d2d2;
      height: 40px;
      line-height: 40px;
      padding: 0 10px 0 19px;
      margin-right: 10px;
      margin-bottom: 20px;
      span {
        width: 40px;
        display: inline-block;
        margin-left: 20px;
        .iconfont {
          font-size: 30px;
        }
      }
    }
  }
  .order_wrap {
    .order_item {
      width: 650px;
      border: 1px solid #d2d2d2;
      margin: 0 auto 30px;
      padding: 40px;
      font-size: 20px;
      color: #3c3c3c;
      box-sizing: border-box;
      .row_one {
        font-size: 22px;

        p {
          margin-bottom: 10px;
          &:last-child {
            margin-bottom: 0;
          }
        }
      }
      .row_shop_list {
        margin: 27px 0 55px;
        color: #3c3c3c;
        .shop_item {
          margin-bottom: 30px;
        }
        .shop_name_num {
          margin-bottom: 22px;
          .shop_name_num_item {
            align-items: flex-start;
            margin-bottom: 4px;
          }
          p {
            font-size: 20px;
            &.label {
              white-space: nowrap;
            }
          }
        }
        .shop_price {
          font-size: 18px;
          .txt {
            margin-top: 10px;
          }
        }
      }
      .row_two {
        margin-bottom: 40px;
        p {
          margin-bottom: 6px;
          &:last-child {
            margin-bottom: 0;
          }
        }
      }
      .row_three {
        margin-bottom: 36px;
        font-size: 22px;
      }
      .row_four {
        margin-bottom: 30px;
        font-size: 22px;
        span {
          margin-right: 17px;
        }
        .txt {
          margin-bottom: 10px;
          p {
            // &:last-child {
            //   font-size: 30px;
            // }
          }
          span {
            font-size: 20px;
          }
        }
        .txt1 {
          margin-bottom: 30px;
        }
      }
      .order_status {
        font-size: 22px;
        .txt {
          margin-bottom: 10px;
        }
        .red {
          color: #ee0032;
        }
      }
      .mb {
        margin-bottom: 30px;
      }
    }
  }
}
</style>